import { render, staticRenderFns } from "./SelectClientDialog.vue?vue&type=template&id=198aec83"
import script from "./SelectClientDialog.vue?vue&type=script&lang=js"
export * from "./SelectClientDialog.vue?vue&type=script&lang=js"
import style0 from "./SelectClientDialog.vue?vue&type=style&index=0&id=198aec83&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports